import React,{useState,useEffect,CSSProperties } from 'react'
import Blog from './Blog'
import "../styles/blogs.css"
// import Parser from 'react-rss'
// let parser = new Parser();
import blogData from './blogData';
import PacmanLoader	 from "react-spinners/PacmanLoader";


const override: CSSProperties = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
  marginTop:"21rem",
};


 function Blogs() {
  let [loading, setLoading] = useState(true);

  useEffect(()=>{
    setTimeout(()=>{
        setLoading(false);
    },1200)
  })
  return (
    <div className="blogs">
      {loading ?  <PacmanLoader color={"#feb800"} loading={true} cssOverride={override} size={25}/>
                    :
                    <>
      <div className='flex'>
      <h1 className="blogs__heading">Blogs</h1>
      <span>
      <a className="btn" style={{marginTop:0}} href="https://dev.to/jay818" target="_blank" rel="noreferrer">Dev.to</a>
      </span>
      </div>
      <hr className='blogs__hr'/>
      <div className="blogs__blog">
        
        {blogData.map((blog)=>{
          return(
            <Blog
              key={blog.id}
              title={blog.title}
              description={blog.description}
              link={blog.link}
              pubDate={blog.pubDate}
              thumbnail={blog.image}
              category={blog.category}
            />
          );
        })}

</div>
</>
      // <div className="blogs__container"></div>
 }
    </div>
  );
}

     

export default Blogs;





